import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { saveFollowupInteraction } from '../../api/Followup';

interface LogFollowupModalProps {
  onClose: () => void;
  onOutcomeAction: (outcome: OutcomeType, queryId: number) => void;
  queryId: number;
  followupId: number;
}

export type OutcomeType = '' | 'quotation' | 'followup' | 'closed' | 'booked' | 'no_response';

const LogFollowupModal: React.FC<LogFollowupModalProps> = ({
  onClose,
  onOutcomeAction,
  queryId,
  followupId
}) => {
  const [notes, setNotes] = useState('');
  const [outcome, setOutcome] = useState<OutcomeType>('');

  const handleSubmit = () => {
    saveFollowupInteraction(followupId, notes, outcome)
      .then(() => onOutcomeAction(outcome, queryId))
      .then(() => toast.success('Followup Interaction captured'))
      .catch(() => toast.error('Followup Interaction capture failed'))
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>Log Interaction</h2>

        <label>
          Meeting Notes <span className="required">*</span>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            required
          />
        </label>

        <label>
          Outcome <span className="required">*</span>
          <select
            value={outcome}
            onChange={(e) => setOutcome(e.target.value as OutcomeType)}
          >
            <option value=""></option>
            <option value="quotation">Customer requested a quotation</option>
            <option value="followup">Another follow-up needed</option>
            <option value="closed">Customer wants to close</option>
            <option value="booked">Customer wants to book</option>
            <option value="no_response">Customer not responsive</option>
          </select>
        </label>

        <div className="modal-actions">
          <button onClick={handleSubmit} disabled={!notes}>Save</button>
          <button className="secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default LogFollowupModal;
